import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ErrorMessageService } from 'src/app/shared/services/error-message.service';

export interface ChatMessage {
  content: string;
  isUser: boolean;
  timestamp: Date;
}

export interface ChatbotRequest {
  question: string;  // Correspond au backend Flask
  domain?: string;   // Nouveau: domaine (emprunteur/sante)
}

export interface ChatbotResponse {
  answer: string;   // Correspond au backend Flask
  error?: string;
}

@Injectable({
  providedIn: 'root'
})
export class ChatbotService {
  private apiUrl = `${environment.apiUrl}${environment.apiEndpoint}`;
  private chatbotEndpoint = `${this.apiUrl}/chatbot`;

  constructor(
    private http: HttpClient,
    private errorMessageService: ErrorMessageService
  ) {}

  /**
   * Get authentication headers with proper token handling
   */
private getHeaders() {
  const token = localStorage.getItem('access_token');
  console.log('🔑 Token found:', token ? `YES (${token.substring(0, 20)}...)` : 'NO TOKEN');
  
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  };
}

  /**
   * Send message to chatbot via FastAPI backend (which then calls Flask)
   */
  askQuestion(message: string, domain: string = 'emprunteur'): Observable<ChatbotResponse> {
    const payload: ChatbotRequest = { question: message, domain };
    
    console.log('🤖 Sending to chatbot:', this.chatbotEndpoint, payload);
    console.log('🔑 Auth headers:', this.getHeaders());
    
    // Configuration spécifique pour le chatbot avec timeout désactivé
    const options = {
      ...this.getHeaders(),
      timeout: 0 // Pas de timeout
    };
    
    return this.http.post<ChatbotResponse>(this.chatbotEndpoint, payload, options)
      .pipe(
        map(response => {
          console.log('📥 Raw chatbot response:', response);
          console.log('📥 Raw answer content:', response.answer); 
          
          const cleanedAnswer = this.cleanHtmlTags(response.answer);
          console.log('🧹 Cleaned answer content:', cleanedAnswer);
          
          const finalResponse = {
            ...response,
            answer: cleanedAnswer
          };
          
          console.log('✅ Final processed response:', finalResponse);
          return finalResponse;
        }),
        catchError(this.handleError)
      );
  }
  /**
   * Remove HTML tags from text
   */
  private cleanHtmlTags(text: string): string {
    if (!text) return '';
    
    return text.replace(/<[^>]*>/g, '')
               .replace(/&nbsp;/g, ' ')
               .replace(/&amp;/g, '&')
               .replace(/&lt;/g, '<')
               .replace(/&gt;/g, '>')
               .replace(/&quot;/g, '"')
               .trim();
  }

  /**
   * Handle HTTP errors
   */
  private handleError(error: HttpErrorResponse): Observable<never> {
    console.error('Chatbot service error:', error);
    
    // Utiliser le service centralisé pour obtenir un message clair
    const { detail } = this.errorMessageService.getErrorMessage(error);
    
    return throwError(() => new Error(detail));
  }
}